import * as React from "react";
function SvgBilibili(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={32} height={32} fill="currentColor" rx={6} ry={6} />
      <g fill="#fff">
        <path d="M22.25 10.06h-1.14l1.05-.95c.51-.46.55-1.25.08-1.77a1.25 1.25 0 00-1.77-.08l-3.08 2.8h-2.78l-3.08-2.8a1.25 1.25 0 00-1.77.08c-.46.51-.43 1.3.08 1.77l1.05.95H9.75C7.68 10.06 6 11.74 6 13.81v7.5c0 2.07 1.68 3.75 3.75 3.75h12.5c2.07 0 3.75-1.68 3.75-3.75v-7.5c0-2.07-1.68-3.75-3.75-3.75zm1.25 11.25c0 .69-.56 1.25-1.25 1.25H9.75c-.69 0-1.25-.56-1.25-1.25v-7.5c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v7.5z" />
        <path d="M12.25 14.75c-.69 0-1.25.56-1.25 1.25v1.88a1.25 1.25 0 002.5 0V16c0-.69-.56-1.25-1.25-1.25zm7.5 0c-.69 0-1.25.56-1.25 1.25v1.88a1.25 1.25 0 002.5 0V16c0-.69-.56-1.25-1.25-1.25z" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBilibili);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
